import * as React from 'react';
import { trackFullscreenClick } from '../utils';

interface IUseFullscreenProps {
  isFullscreenOpen: boolean;
  handleFullscreenEnter: () => void;
  handleFullscreenExit: () => void;
}

export const useFullscreenProps = (): IUseFullscreenProps => {
  const [isFullscreenOpen, setFullscreenOpen] = React.useState(false);

  const handleFullscreenEnter = React.useCallback(() => {
    setFullscreenOpen(true);
    trackFullscreenClick();
  }, []);

  const handleFullscreenExit = React.useCallback(() => {
    setFullscreenOpen(false);
  }, []);

  return {
    isFullscreenOpen,
    handleFullscreenEnter,
    handleFullscreenExit,
  };
};
